import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material'

interface ResetStageProps {
  reset: () => Promise<void>
  isResetting: boolean
  buttonText?: string
  dialogTitle?: string
  dialogContentText?: string
  buttonSx?: object
}

export function ResetStage({
  reset,
  isResetting,
  buttonText = 'Reset stage',
  dialogTitle = 'Reset stage?',
  dialogContentText = 'This will delete any in-progress flow and clear results for this stage.',
  buttonSx,
}: ResetStageProps) {
  const [confirmOpen, setConfirmOpen] = useState(false)

  const handleConfirm = async () => {
    setConfirmOpen(false)
    await reset()
  }

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setConfirmOpen(true)}
        disabled={isResetting}
        sx={{ mt: 1, ...buttonSx }}
      >
        {isResetting ? 'Resetting…' : buttonText}
      </Button>
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogContentText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirm} color="error">
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
